import React, {useEffect, useState} from "react"
import { Card, CardBody } from "reactstrap"
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {promotionActivityService} from "../../../jwt/_services/promotions/promotionActivityService";
import Loading from "../../../components/loader/Loading";
import {ToastContainer} from "react-toastify";


const ConfirmationSendingNotification = ({ path, onClose, promotionActivity}) =>  {
    const notificationLangs = promotionActivity?.notification?.langs || []

    const [notifying, setNotifying] = useState(false)
    const [notificationResponse, setNotificationResponse] = useState({})



    useEffect(() => {
        if (notificationResponse?.status === false) {
            const timer = setTimeout(() => {
                setNotificationResponse({});
            }, 3000);

            return () => clearTimeout(timer); // Limpia el temporizador al desmontar
        }
    }, [notificationResponse]);



    
    const notifyPromotion =  async  () => {
        setNotifying(true)

        const response = await genericIndexedActions.notify( path, promotionActivityService, {item: {id: promotionActivity?.id}}, ()=> setNotifying(false))
        setNotificationResponse(response)

    }
    

    
    return <Card className={'card-modal'}>
        <CardBody className={'custom-ui'}>

            {
                notifying && <Loading isLoading={true} title={ 'Enviando la notificación' }/>
            }

            {
                notificationResponse?.status === false && <div className={'internal-error'}>
                    {notificationResponse?.message}
                </div>
            }


            <h1>{'Enviar la notificación'}</h1>
            <p>{'Por favor confirma que quieres enviar la notificación'}</p>


            {
                notificationLangs.map(   ( item, index) => {
                    const {title, body, lang:{name} } = item || {}

                        return <div className={"mb-2 text-align-left"} key={index}>
                            <h3>En el idioma {name} enviaras:</h3>
                        <hr/>
                        Title: {title} <br/>
                        Cuerpo: {body}
                            <br/>
                            <br/>
                            <br/>
                    </div>
                })
            }


            <button className={"btn-alert-delete"} onClick={onClose}>
                No enviar
            </button>
            <button  onClick={() => {
                notifyPromotion()
                //onClose();
            }}>
                Enviar notificación
            </button>
        </CardBody>
    </Card>
}

export default ConfirmationSendingNotification